import { Record, Map } from 'immutable';
import { actionTypes, fetchIntakeFormsActions, pagingActions, fetchFormPreviewActions } from './intake-forms.actions';
import { addFormActions, updateFormActions } from './modify-intake-form/modify-intake-form.actions';
import { publishActions, retractActions } from './publish-intake-form/publish-intake-form.actions';
import * as api from '../api';
import { pagingDataUtilities } from '../common';

export const CreateIntakeFormState = Record({
  showSelectSiteModal: false,
  currentSelectedSite: "",
  currentSelectedProgram: ""
});

export const IntakeFormsState = Record({
  create: CreateIntakeFormState({}),
  filterSite: null,
  intakeForms: api.ApiCallState({}),
  pagingData: pagingDataUtilities.PagingState({
    sortBy: 'site'
  }),
  formPreviews: Map({})
});

export const intakeFormsReducer = (initialState = new IntakeFormsState(), action) => {
  var state = initialState.set('pagingData',
    pagingDataUtilities.pagingReducer(initialState.get('pagingData'), action, pagingActions));

  var invalidateActions = pagingActions.allTypes
    .concat([
      addFormActions.success,
      updateFormActions.success,
      publishActions.success,
      retractActions.success,
      actionTypes.SET_FILTER_SITE
    ]);
  state = state.set('intakeForms',
    api.apiCallReducer(state.get('intakeForms'), action, fetchIntakeFormsActions, invalidateActions));

  if(action.formId) {
    state = state.setIn(['formPreviews', action.formId],
      api.apiCallReducer(state.getIn(['formPreviews', action.formId]), action, fetchFormPreviewActions));
  }

  switch(action.type) {
    case actionTypes.SHOW_SELECT_SITE_MODAL:
      return state.setIn(['create', 'currentSelectedSite'], "")
                  .setIn(['create', 'currentSelectedProgram'], "")
                  .setIn(['create', 'showSelectSiteModal'], true);
    case actionTypes.CLOSE_SELECT_SITE_MODAL:
      return state.setIn(['create', 'showSelectSiteModal'], false);
    case actionTypes.SET_SELECTED_SITE:
      return state.setIn(['create', 'currentSelectedSite'], action.siteId)
                  .setIn(['create', 'currentSelectedProgram'], "");
    case actionTypes.SET_SELECTED_PROGRAM:
      return state.setIn(['create', 'currentSelectedProgram'], action.programId);
    case actionTypes.CONFIRM_SELECTION:
      return state.set('create', new CreateIntakeFormState({}));
    case actionTypes.SET_FILTER_SITE:
      return state.set('filterSite', action.siteId);
    case updateFormActions.begin:
      return state.setIn(['formPreviews', action.id], new api.ApiCallState({ isValid : false }));
    default:
      return state;
  }
}
